import { createRouter, createWebHistory } from "vue-router";
import { utilsRoute } from "./utils";
import { vue3Route } from "./vue-3";
import NProgress from "nprogress";
import { authBasicCheck } from "@/api/v1/auth";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";

export const routes = [
  {
    path: "/",
    component: () => import("@/layout"),
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/home"),
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login"),
      },
      {
        path: "/memrise",
        name: "Memrise",
        component: () => import("@/views/memrise"),
      },
      {
        path: "/translate",
        name: "Translate",
        component: () => import("@/views/translate"),
      },
      {
        path: "/cheatography",
        name: "Cheatography",
        component: () => import("@/views/cheatography"),
      },
      {
        path: "/vue2-to-vue3",
        name: "VueMigrate",
        component: () => import("@/views/vue-migrate"),
      },
      {
        path: "/test-data",
        name: "TestData",
        component: () => import("@/views/test-data"),
      },
      {
        path: "/chat-gpt",
        name: "ChatGPT",
        component: () => import("@/views/chat-gpt"),
      },
      {
        path: "/japan-n5",
        name: "JapanN5",
        component: () => import("@/views/japan-n5"),
      },
      {
        path: "/english",
        name: "English",
        component: () => import("@/views/english"),
      },
      {
        path: "/validate-laravel",
        name: "ValidateLaravel",
        component: () => import("@/views/validate-laravel"),
      },
      {
        path: "/growupwork-generate-cms",
        name: "GrowupWorkGenerateCMS",
        component: () => import("@/views/growupwork-generate-cms"),
      },
      {
        path: "/add-component-guild-line",
        name: "AddComponentGuildline",
        component: () => import("@/views/add-component-guild-line"),
      },
      {
        path: "/aws-developer-certificate/learn/:key",
        name: "AWSDeveloperCertificateLearn",
        component: () => import("@/views/aws-developer-certificate/learn.vue"),
      },
      {
        path: "/aws-developer-certificate",
        name: "AWSDeveloperCertificate",
        component: () => import("@/views/aws-developer-certificate"),
      },
      {
        path: "/aws-developer-certificate-vn",
        name: "AWSDeveloperCertificateVN",
        component: () => import("@/views/aws-developer-certificate-vn"),
      },
      {
        path: "/aws-developer-certificate-vn/learn/:key",
        name: "AWSDeveloperCertificateLearnVN",
        component: () =>
          import("@/views/aws-developer-certificate-vn/learn.vue"),
      },
      {
        path: "/anki",
        name: "Anki",
        component: () => import("@/views/anki"),
      },
      {
        path: "/spend",
        name: "Spend",
        component: () => import("@/views/spend"),
      },
      {
        path: "/spend-report",
        name: "SpendReport",
        component: () => import("@/views/spend/report"),
      },
      {
        path: "/mark",
        name: "Mark",
        component: () => import("@/views/mark"),
      },
      {
        path: "/daily-todo",
        name: "DailyTodo",
        component: () => import("@/views/daily-todo"),
      },
      {
        path: "/web5ngay",
        name: "Web5ngay",
        component: () => import("@/views/web5ngay"),
      },
      {
        path: "/crud-wordpress-plugin",
        name: "CrudWordpressPlugin",
        component: () => import("@/views/crud-wordpress-plugin"),
      },
      {
        path: "/study",
        name: "Study",
        component: () => import("@/views/study"),
      },
      {
        path: "/study-level/:id",
        name: "StudyLevel",
        component: () => import("@/views/study/study-level"),
      },
      {
        path: "/study-content/:course_id/:level_id",
        name: "StudyContent",
        component: () => import("@/views/study/study-content"),
      },
      {
        path: "/study-learn/:course_id/:level_id",
        name: "StudyLearn",
        component: () => import("@/views/study/learn"),
      },
      {
        path: "/study/add/:course_id/:level_id",
        name: "StudyAdd",
        component: () => import("@/views/study/add"),
      },
      {
        path: "/study/learn-choice/:course_id/:level_id",
        name: "StudyChoice",
        component: () => import("@/views/study/learn-choice"),
      },
      {
        path: "/study/learn-recall/:course_id/:level_id",
        name: "StudyRecall",
        component: () => import("@/views/study/learn-recall"),
      },
      {
        path: "/news",
        name: "News",
        component: () => import("@/views/news"),
      },
      {
        path: "/freelancer-quote",
        name: "FreelancerQuote",
        component: () => import("@/views/freelancer-quote"),
      },
      {
        path: "/goals",
        name: "Goals",
        component: () => import("@/views/goals"),
      },
      {
        path: "/guild-line-module",
        name: "GuildLineModule",
        component: () => import("@/views/guild-line-module/home"),
      },
      {
        path: "/blog-it",
        name: "BlogIT",
        component: () => import("@/views/blog-it"),
      },
      ...utilsRoute,
      ...vue3Route,
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  mode: "history",
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { el: to.hash };
    } else {
      return { top: 0 };
    }
  },
});

// middleware route
router.beforeEach(async (to, from, next) => {
  // Step 1: start progress bar
  NProgress.start();

  // Step 2: get auth store
  const authStore = useAuthStore();
  const { isLogin } = storeToRefs(authStore);

  // Step 3: check route white list
  if (to.name === "Login") {
    next();
  } else {
    // Step 4: get token
    const token = localStorage.getItem("token");

    // Step 5: check token not exist => redirect to login
    if (!token) {
      next({ name: "Login" });
    } else {
      // Step 6: check isLogin
      if (isLogin.value) {
        next();
      } else {
        // Step 7: not login, have token => check token
        try {
          await authBasicCheck({ token });

          // Step 8: set login
          authStore.setLogin(true);

          // Step 9: OK => next
          next();
        } catch (error) {
          // Step 10: error => redirect to login
          console.log(error);
          next({ name: "Login" });
        }
      }
    }
  }
});

export default router;
